(function () {
  'use strict';

  if (window.UnifiedHealth) {
    return;
  }

  const VERSION = '1.2.0';

  function checkModule(name, reference, requiredMethods) {
    const available = Boolean(reference);
    const methods = {};

    (requiredMethods || []).forEach(function (methodName) {
      methods[methodName] = Boolean(
        reference && typeof reference[methodName] === 'function'
      );
    });

    const missingMethods = Object.keys(methods).filter(function (methodName) {
      return methods[methodName] !== true;
    });

    return {
      name: name,
      available: available,
      version: reference && reference.version ? reference.version : '',
      methods: methods,
      missing_methods: missingMethods,
      healthy: available && missingMethods.length === 0
    };
  }

  function checkConfig() {
    const config = window.UnifiedTrackingConfig;
    const issues = [];

    if (!config) {
      issues.push('configuration_unavailable');
      return { available: false, version: '', issues: issues, healthy: false };
    }

    if (!config.version) issues.push('version_missing');
    if (!config.providers || typeof config.providers !== 'object') issues.push('providers_missing');
    if (!config.events || typeof config.events !== 'object') issues.push('events_missing');

    return {
      available: true,
      version: config.version || '',
      debug: config.debug === true,
      consent_required: config.consentRequired === true,
      events_count: config.events ? Object.keys(config.events).length : 0,
      issues: issues,
      healthy: issues.length === 0
    };
  }

  function checkProject() {
    const project = window.UnifiedProjectConfig || null;
    const id = project && project.project ? String(project.project) : '';

    return {
      available: Boolean(project),
      id: id,
      version: project && project.version ? String(project.version) : '',
      healthy: Boolean(project && id)
    };
  }

  function checkGA4() {
    const config = window.UnifiedTrackingConfig || {};
    const project = window.UnifiedProjectConfig || {};
    const enabled = Boolean(config.providers && config.providers.ga4 === true);
    const available = typeof window.gtag === 'function';
    const destination = project.ga4 && project.ga4.measurementId
      ? String(project.ga4.measurementId)
      : '';

    return {
      enabled: enabled,
      available: available,
      destination: destination,
      healthy: !enabled || (available && Boolean(destination)),
      status: !enabled
        ? 'disabled'
        : available && destination
          ? 'available'
          : 'unavailable'
    };
  }

  function checkClarity() {
    const config = window.UnifiedTrackingConfig || {};
    const project = window.UnifiedProjectConfig || {};
    const enabled = Boolean(config.providers && config.providers.clarity === true);
    const available = typeof window.clarity === 'function';
    const expectedProjectId = project.clarity && project.clarity.projectId
      ? String(project.clarity.projectId)
      : '';

    return {
      enabled: enabled,
      available: available,
      expected_project_id: expectedProjectId,
      healthy: !enabled || (available && Boolean(expectedProjectId)),
      status: !enabled
        ? 'disabled'
        : available && expectedProjectId
          ? 'available'
          : 'unavailable'
    };
  }

  function checkConsent() {
    const config = window.UnifiedTrackingConfig || {};
    const required = config.consentRequired === true;
    const unifiedConsent = window.UnifiedConsent;

    if (
      unifiedConsent &&
      typeof unifiedConsent.analyticsAllowed === 'function'
    ) {
      try {
        return {
          required: required,
          api_available: true,
          allowed: unifiedConsent.analyticsAllowed(),
          healthy: true,
          status: 'available',
          source: 'unified_consent'
        };
      } catch (error) {
        return {
          required: required,
          api_available: true,
          allowed: null,
          healthy: false,
          status: 'error',
          source: 'unified_consent',
          error: error.message
        };
      }
    }

    const shopifyAvailable = Boolean(window.Shopify && window.Shopify.customerPrivacy);
    const methodAvailable = Boolean(
      shopifyAvailable &&
      typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
    );

    let allowed = null;

    if (methodAvailable) {
      try {
        allowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed();
      } catch (error) {
        return {
          required: required,
          api_available: true,
          allowed: null,
          healthy: false,
          status: 'error',
          source: 'shopify_customer_privacy',
          error: error.message
        };
      }
    }

    return {
      required: required,
      api_available: methodAvailable,
      allowed: allowed,
      healthy: !required || methodAvailable,
      status: !required ? 'not_required' : (methodAvailable ? 'available' : 'unavailable'),
      source: 'shopify_customer_privacy'
    };
  }

  function checkErrors() {
    const manager = window.UnifiedErrors;

    if (!manager || typeof manager.getSummary !== 'function') {
      return { available: false, healthy: false, summary: null };
    }

    const summary = manager.getSummary();
    return { available: true, healthy: summary.fatal === 0, summary: summary };
  }

  function checkPerformance() {
    const monitor = window.UnifiedPerformance;

    if (!monitor || typeof monitor.getSummary !== 'function') {
      return { available: false, healthy: false, summary: null };
    }

    const summary = monitor.getSummary();
    return {
      available: true,
      healthy: summary.active_measurements === 0,
      summary: summary
    };
  }

  function checkBus() {
    const bus = window.UnifiedBus;

    if (!bus || typeof bus.getStats !== 'function') {
      return { available: false, healthy: false, summary: null };
    }

    const summary = bus.getStats();
    return {
      available: true,
      healthy:
        typeof bus.emit === 'function' &&
        typeof bus.on === 'function' &&
        typeof bus.off === 'function',
      summary: summary
    };
  }

  function checkStorageArea(name) {
    const storage = window[name];
    const key = '__ut_health_' + name;

    if (!storage) {
      return false;
    }

    try {
      storage.setItem(key, '1');
      const readable = storage.getItem(key) === '1';
      storage.removeItem(key);
      return readable;
    } catch (error) {
      return false;
    }
  }

  function checkStorage() {
    const localAvailable = checkStorageArea('localStorage');
    const sessionAvailable = checkStorageArea('sessionStorage');

    return {
      local_storage: localAvailable,
      session_storage: sessionAvailable,
      healthy: localAvailable && sessionAvailable
    };
  }

  function describeMissingSection(wrapper, index) {
    if (!wrapper) return 'shopify-section-' + (index + 1);
    if (wrapper.id) return '#' + wrapper.id;
    if (wrapper.className && typeof wrapper.className === 'string') {
      return '.' + wrapper.className.trim().split(/\s+/).filter(Boolean).join('.');
    }
    return 'shopify-section-' + (index + 1);
  }

  function wrapperHasIdentity(wrapper) {
    if (!wrapper) return false;

    try {
      if (
        typeof wrapper.matches === 'function' &&
        wrapper.matches('[data-ut-section]')
      ) {
        return true;
      }

      if (
        typeof wrapper.querySelector === 'function' &&
        wrapper.querySelector('[data-ut-section]')
      ) {
        return true;
      }
    } catch (error) {
      return false;
    }

    return false;
  }

  function checkSections() {
    if (typeof document === 'undefined' || typeof document.querySelectorAll !== 'function') {
      return {
        detected: 0,
        instrumented: 0,
        missing_identity: 0,
        missing: [],
        healthy: true
      };
    }

    const wrappers = Array.from(document.querySelectorAll('.shopify-section') || []);
    const explicit = Array.from(document.querySelectorAll('[data-ut-section]') || []);

    if (!wrappers.length) {
      return {
        detected: explicit.length,
        instrumented: explicit.length,
        missing_identity: 0,
        missing: [],
        healthy: true
      };
    }

    const missing = [];

    wrappers.forEach(function (wrapper, index) {
      if (!wrapperHasIdentity(wrapper)) {
        missing.push(describeMissingSection(wrapper, index));
      }
    });

    return {
      detected: wrappers.length,
      instrumented: wrappers.length - missing.length,
      missing_identity: missing.length,
      missing: missing,
      healthy: missing.length === 0
    };
  }

  function getModules() {
    return {
      bus: checkModule('bus', window.UnifiedBus, [
        'emit', 'on', 'once', 'off', 'getHistory', 'getStats'
      ]),
      debug: checkModule('debug', window.UnifiedDebug, [
        'getHistory', 'printHistory', 'clearHistory'
      ]),
      context: checkModule('context', window.UnifiedContext, [
        'getContext', 'getSessionId', 'getPageSequence'
      ]),
      errors: checkModule('errors', window.UnifiedErrors, [
        'getSummary', 'getAll', 'clear'
      ]),
      journey: checkModule('journey', window.UnifiedJourney, [
        'getJourney', 'getSummary', 'getConversionPath'
      ]),
      performance: checkModule('performance', window.UnifiedPerformance, [
        'getSummary', 'getMeasurements', 'clear'
      ]),
      tracking: checkModule('tracking', window.UnifiedTracking, [
        'track', 'emit', 'getConfig', 'getContext', 'getErrors',
        'getPerformance', 'getBusStats'
      ]),
      detection: checkModule(
        'detection',
        window.UnifiedTracking && window.UnifiedTracking.detect,
        ['currentPage', 'currentService', 'resolveService']
      )
    };
  }

  function getModules21() {
    const modules = {
      consent: checkModule('consent', window.UnifiedConsent, [
        'analyticsAllowed', 'getStatus'
      ]),
      page_context: checkModule('page_context', window.UnifiedPageContext, [
        'getContext'
      ]),
      product_context: checkModule('product_context', window.UnifiedProductContext, [
        'getCurrent', 'fromElement', 'classifyItem'
      ]),
      attribution_context: checkModule('attribution_context', window.UnifiedAttributionContext, [
        'record', 'get', 'snapshot', 'clear'
      ]),
      analytics_projector: checkModule('analytics_projector', window.UnifiedAnalyticsProjector, [
        'project'
      ]),
      visibility_listener: checkModule('visibility_listener', window.UnifiedVisibilityListener, [
        'initialize', 'getStats'
      ]),
      interaction_listener: checkModule('interaction_listener', window.UnifiedInteractionListener, [
        'handleClick', 'handleChange', 'handleSubmit'
      ]),
      shopify_bridge_consumer: checkModule('shopify_bridge_consumer', window.UnifiedShopifyBridgeConsumer, [
        'consumeQueue', 'getQueue'
      ]),
      sommelier_listener: checkModule('sommelier_listener', window.UnifiedSommelierListener, [
        'handleChange', 'handleClick', 'handleResult'
      ]),
      guidance_listener: checkModule('guidance_listener', window.UnifiedGuidanceListener, [
        'handleClick', 'handleChange'
      ]),
      bundle_listener: checkModule('bundle_listener', window.UnifiedBundleListener, []),
      stock_listener: checkModule('stock_listener', window.UnifiedStockListener, [
        'initialize', 'parseStockLimitText'
      ])
    };

    const missing = Object.keys(modules).filter(function (key) {
      return modules[key].healthy !== true;
    });

    return {
      total: Object.keys(modules).length,
      available: Object.keys(modules).length - missing.length,
      missing: missing,
      modules: modules,
      healthy: missing.length === 0
    };
  }

  function calculateScore(checks) {
    const items = [];

    Object.keys(checks.modules).forEach(function (key) {
      items.push(checks.modules[key].healthy);
    });

    Object.keys(checks.modules_2_1.modules).forEach(function (key) {
      items.push(checks.modules_2_1.modules[key].healthy);
    });

    items.push(checks.config.healthy);
    items.push(checks.project.healthy);
    items.push(checks.ga4.healthy);
    items.push(checks.clarity.healthy);
    items.push(checks.consent.healthy);
    items.push(checks.storage.healthy);
    items.push(checks.sections.healthy);
    items.push(checks.errors.healthy);
    items.push(checks.performance.healthy);
    items.push(checks.bus.healthy);

    const passed = items.filter(Boolean).length;
    const total = items.length;

    return {
      passed: passed,
      total: total,
      percentage: total ? Math.round((passed / total) * 100) : 0
    };
  }

  function getStatus() {
    const checks = {
      generated_at: new Date().toISOString(),
      framework_version:
        window.UnifiedTrackingConfig && window.UnifiedTrackingConfig.version
          ? window.UnifiedTrackingConfig.version
          : '',
      project: checkProject(),
      config: checkConfig(),
      modules: getModules(),
      modules_2_1: getModules21(),
      ga4: checkGA4(),
      clarity: checkClarity(),
      consent: checkConsent(),
      storage: checkStorage(),
      sections: checkSections(),
      errors: checkErrors(),
      performance: checkPerformance(),
      bus: checkBus()
    };

    checks.score = calculateScore(checks);
    checks.healthy = checks.score.percentage === 100;
    return checks;
  }

  function isHealthy() {
    return getStatus().healthy;
  }

  function printStatus() {
    const status = getStatus();
    const rows = [];

    rows.push({
      component: 'config',
      available: status.config.available,
      healthy: status.config.healthy,
      version: status.config.version || ''
    });

    Object.keys(status.modules).forEach(function (key) {
      const module = status.modules[key];
      rows.push({
        component: key,
        available: module.available,
        healthy: module.healthy,
        version: module.version || ''
      });
    });

    Object.keys(status.modules_2_1.modules).forEach(function (key) {
      const module = status.modules_2_1.modules[key];
      rows.push({
        component: key,
        available: module.available,
        healthy: module.healthy,
        version: module.version || ''
      });
    });

    rows.push({
      component: 'ga4',
      available: status.ga4.available,
      healthy: status.ga4.healthy,
      version: ''
    });

    rows.push({
      component: 'clarity',
      available: status.clarity.available,
      healthy: status.clarity.healthy,
      version: ''
    });

    rows.push({
      component: 'consent',
      available: status.consent.api_available,
      healthy: status.consent.healthy,
      version: ''
    });

    console.table(rows);

    console.info('[Unified Health] Health summary', {
      healthy: status.healthy,
      score: status.score.percentage + '%',
      passed: status.score.passed,
      total: status.score.total,
      project: status.project,
      sections: status.sections,
      modules_2_1: status.modules_2_1,
      bus: status.bus.summary,
      errors: status.errors.summary,
      performance: status.performance.summary
    });

    return status;
  }

  window.UnifiedHealth = {
    version: VERSION,
    getStatus: getStatus,
    printStatus: printStatus,
    isHealthy: isHealthy
  };

  if (window.UnifiedTrackingConfig && window.UnifiedTrackingConfig.debug) {
    console.info('[Unified Health] Health Monitor initialized', {
      version: VERSION
    });
  }
})();
